import { FC, CSSProperties } from 'react';
import classnames from 'classnames';

interface IProps {
  className?: string;
  style?: CSSProperties;
}

const Divider: FC<IProps> = ({ className, style = {} }) => {
  const originalStyle = {
    height: 12,
    background: '#F5F5F5',
  };
  return (
    <div
      className={classnames({ [className as string]: !!className })}
      style={{ ...originalStyle, ...style }}
    />
  );
};

export default Divider;
